/* eslint-disable react/no-multi-comp */
import React from "react"
import { Link } from "gatsby"
import { css, logTool } from "@jsUtils"
import { Circle, Analytics } from "@shared"

import Styles from "./cta.module.scss"

const log = logTool(false)

const TrackedLink = Analytics("a")

const Anchor = props => {
  const { to, target } = props
  const newProps = {
    ...props,
    href: to,
    ...(!!target && { target })
  }
  delete newProps.to
  log("Anchor: ", props, newProps)
  return <TrackedLink {...newProps}>{newProps.children}</TrackedLink>
}

/**
 * CTA with a circle to the left
 * @param {object} props - react props
 * @param {string} props.theme - background color theme (light/dark)
 * @param {string} props.color - circle color
 * @param {boolean} props.filled - filled circle styling
 * @param {boolean} props.flipped - horizontally flipped circle
 * @param {string} props.className - class name
 * @param {string} props.to - link destination
 * @param {boolean} props.anchor - are we using a native, external anchor link?
 * @param {boolean} props.target - are we setting a blank target?
 * @param {object} props.dataProps - data properties injected by the Analytics HOC
 * @param {string} props.content - circle icon
 * @param {boolean} props.isBtn - is a button or not
 */
const CTA = props => {
  const {
    children,
    color,
    theme,
    flipped,
    className,
    to,
    anchor,
    target,
    ready,
    rel,
    tabIndex,
    dataProps,
    content,
    isBtn,
    onClick
  } = props
  const Component = isBtn ? "button" : anchor ? Anchor : Link
  return (
    <Component
      {...dataProps}
      className={css(
        Styles.cta,
        color && Styles[color],
        theme && Styles[`theme_${theme}`],
        ready && Styles.ready,
        className
      )}
      target={target}
      rel={rel}
      to={to}
      tabIndex={tabIndex}
      type={isBtn && "button"}
      onClick={isBtn && onClick}
    >
      <>
        <div className={Styles.circle}>
          <Circle color={color} theme={theme} flipped={flipped} content={content || "chevron"} />
        </div>
        <div className={Styles.copy}>{children}</div>
      </>
    </Component>
  )
}

export default CTA
